import { Type } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Closeable, { CloseEventListener } from '@philips-emr/tws-core/lib/component/types/closeable';
import { createAbort, noop } from '@philips-emr/tws-utils';

export interface NotificationData {
  date: string;
  description: string;
  id: number;
  read: boolean;
  title: string;
  type: Type;
}

class NotificationCenterAPI extends ComponentAPI implements Closeable, Clickable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onClose = new CloseEventListener();

  /** @event */
  @AwesomeEvent
  onBeforeClose = new CloseEventListener();

  close(): void {
    if (!this.state.open) {
      return;
    }

    const abort = createAbort();
    this.onBeforeClose.fire({ abort });

    abort.promise.then(aborted => {
      if (aborted) return;
      this.onClose.fire({ open: false, abort: noop });
    });
  }

  setBadge(badge: string): void {
    this.setState({ badge });

  }

  getBadge(): string {
    return this.state.badge;
  }

  getData(): NotificationData {
    return this.state.data;
  }

  setData(data: NotificationData): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  setNotificationTitle(title: string): void {
    this.setState({ title });
  }

  getNotificationTitle(): string {
    return this.state.title;
  }

  setNativeOnMobile(nativeOnMobile: boolean): void {
    this.setState({ nativeOnMobile });

  }

  isNativeOnMobile(): boolean {
    return this.state.nativeOnMobile;
  }

  setOpen(open: boolean): void {
    this.setState({ open });

  }

  isOpen(): boolean {
    return this.state.open;
  }
}

export default NotificationCenterAPI;
